export default __webpack_public_path__ + "static/media/W.cb44f3db.svg";